import Swiper from "swiper";
import {
  Scrollbar,
  FreeMode,
  Navigation,
  Mousewheel,
  Pagination,
  Autoplay,
} from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BREAKPOINTS = {
  tablet: 750,
  desktop: 990,
  desktop_medium: 1200,
  desktop_large: 1440,
};

export default class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    const isVariableWidth = this.hasAttribute("data-variable-width");
    const mobileSlides = isVariableWidth ? "auto" : 2;
    const tabletSlides = isVariableWidth ? "auto" : 3;
    const slides = isVariableWidth ? "auto" : 4;

    const rawOptions =
      JSON.parse(this.getAttribute("data-swiper-options") ?? "{}") ?? {};

    const {
      scrollbar = {},
      pagination = {},
      navigation = {},
      ...restOptions
    } = rawOptions;

    const options = {
      mousewheel: {
        forceToAxis: true,
      },
      direction: "horizontal",
      grabCursor: true,
      freeMode: true,
      scrollbar: {
        draggable: true,
        enabled: true,
        ...scrollbar,
        el: scrollbar.el
          ? this.querySelector(scrollbar.el)
          : this.querySelector(".swiper-scrollbar"),
      },
      pagination: {
        clickable: true,
        ...pagination,
        el: pagination.el
          ? this.querySelector(pagination.el)
          : this.querySelector(".swiper-pagination"),
      },
      navigation: {
        lockClass: "no-lock",
        enabled: true,
        ...navigation,
        prevEl: navigation.prevEl
          ? this.querySelector(navigation.prevEl)
          : this.querySelector(".swiper-button-prev"),
        nextEl: navigation.nextEl
          ? this.querySelector(navigation.nextEl)
          : this.querySelector(".swiper-button-next"),
        disabledClass: navigation.disabledClass ?? "swiper-button--disabled",
      },
      slidesPerView: mobileSlides,
      spaceBetween: 10,
      // Responsive breakpoints, >= breakpoint
      breakpoints: {
        [BREAKPOINTS.tablet]: {
          slidesPerView: tabletSlides,
          spaceBetween: 10,
        },
        [BREAKPOINTS.desktop]: {
          slidesPerView: slides,
          spaceBetween: 16,
        },
      },
      modules: [
        Scrollbar,
        FreeMode,
        Navigation,
        Mousewheel,
        Pagination,
        Autoplay,
      ],
      on: {
        init: (swiper) => {
          // Ensure swiper updates and positions correctly on initialization
          // This fixes the issue where first item doesn't show on first load
          // Use requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
            swiper.update();
            swiper.slideTo(0, 0); // Go to first slide without animation
          });
        },
        afterInit: (swiper) => {
          // Update again after initialization to ensure proper positioning
          swiper.update();
          swiper.slideTo(0, 0);
          this.handleAfterInit(swiper);
        },
        fromEdge: (swiper) => {},
        toEdge: (swiper) => {},
        slideChange: (swiper) => this.handleSlideChange(swiper),
        resize: (swiper) => swiper.update(),
      },
      ...restOptions,
    };

    const swiper = new Swiper(this.querySelector(".swiper"), options);

    /**
      * subscribe to events (use it if the event is not depended on DOM, else use AddEventListener)
      subscribe(PUB_SUB_EVENTS.swiperReinit, (data) => swiper.update());

      * To use swiper methods outside of this class (if this event is not depend on DOM, else use dispatchEvent)
      publish(PUB_SUB_EVENTS.swiperReinit, data);

      * reference: /assets/pubsub.js
    **/
  }

  handleSlideChange(swiper) {
    publish(PUB_SUB_EVENTS.swiperSlideChange, swiper);
  }

  handleAfterInit(swiper) {
    publish(PUB_SUB_EVENTS.swiperAfterInit, swiper);
  }
}

customElements.define("swiper-carousel", SwiperCarousel);

// handle image loaded after slide change
(function () {
  const handleImageLoad = (image) => {
    if (!image.hasAttribute("data-swiper-lazy-load")) return;
    const dataSrcSet = image.getAttribute("data-srcset");
    const dataSrc = image.getAttribute("data-src");
    const dataSizes = image.getAttribute("data-sizes");

    if (dataSrcSet) {
      image.setAttribute("srcset", dataSrcSet);
    }
    if (dataSrc) {
      image.setAttribute("src", dataSrc);
    }
    if (dataSizes) {
      image.setAttribute("sizes", dataSizes);
    }
    image.removeAttribute("data-swiper-lazy-load");
  };

  const ELM_swiperSlides = document.querySelectorAll(
    "swiper-carousel .swiper-slide",
  );
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const images = entry.target.querySelectorAll("img");
        images.forEach((image) => handleImageLoad(image));
        observer.unobserve(entry.target);
      }
    });
  });

  ELM_swiperSlides.forEach((swiperSlide) => {
    observer.observe(swiperSlide);
  });
})();

// PD drawer
(function () {
	function openDrawer(drawerId, isOpenFromDrawer) {
		const $drawerId = $(`#${drawerId}`);
		$drawerId.addClass('active');
		if (isOpenFromDrawer) {
			$drawerId.addClass('open-from-drawer')
		} else {
			$drawerId.removeClass('open-from-drawer')
		}
		$('html').addClass('opening-drawer');
	}

	function closeDrawer(isAll, drawerId) {
		if (isAll) {
			$('.js-pd-drawer').removeClass('active');
			$('html').removeClass('opening-drawer');
		} else {
			$(`#${drawerId}`).removeClass('active');
		}
	}

	$('[data-drawer-id]').on('click', e => {
		const $openBtn = $(e.currentTarget);

		if ($openBtn.attr('disabled')) {
			return;
		}

		if ($openBtn.data('close-other-drawers')) {
			closeDrawer(true);
		}
		const isOpenFromDrawer = $openBtn.parents().closest('.js-pd-drawer.active').length;
		const drawerId = $openBtn.data('drawer-id');
		openDrawer(drawerId, isOpenFromDrawer);
	});

	$('[data-close-drawer]').on('click', e => {
		const $closeBtn = $(e.currentTarget);
		const drawerId = $closeBtn.data('close-drawer');
		$(`#${drawerId}`).removeClass('active');
		closeDrawer(false, drawerId);
	});

	$(document).on('keyup', e => {
		if (e.key === "Escape") {
			closeDrawer(true);
		};
	})

	$('[data-close-all-drawers]').on('click', e => {
		closeDrawer(true);
	});
})();

// handle active image on PDP gallery
(function() {
	const $pdpImage = $('[data-pdp-variant-swiper-id]');
	if (!$pdpImage.length) return;
	$pdpImage.on('click', e => {
		const $elm = $(e.currentTarget);
		const imageId = $elm.data('pdp-variant-swiper-id');
		if (imageId) {
			$('.product-gallery__image-wrapper').removeClass('active');
			$(`[data-image-id=${imageId}]`).addClass('active');
		}
		const $wrapperDrawer = $elm.closest('.drawer-swatch');
		const $closeBtn = $wrapperDrawer.find('.pd-drawer__close');
		if ($wrapperDrawer.length && $closeBtn.length) {
			$closeBtn.trigger('click')
		}
	});

	function initByCurrentVariant() {
		const $currentFeature = $('[data-feature-image-id]');
		if (!$currentFeature.length) return;
		const imageId = $currentFeature.data('feature-image-id');
		if (imageId) {
			$('.product-gallery__image-wrapper').removeClass('active');
			$(`[data-image-id=${imageId}]`).addClass('active');
		}
	}

	initByCurrentVariant();
}());

// Global tab functionality
(function() {
	function initTabs() {
		// Find all tab containers
		$('[data-tab]').each(function() {
			const $container = $(this);
			const $tabButtons = $container.find('[data-tab-content-id]');
			const $tabContents = $container.find('[data-tab-content]');

			// Initialize: set first active button and content
			const $activeButton = $tabButtons.filter('.is-active').first();
			if ($activeButton.length) {
				const activeContentId = $activeButton.data('tab-content-id');
				$tabContents.removeClass('is-active');
				$(`#${activeContentId}`).addClass('is-active');
			} else {
				// If no active button, activate the first one
				const $firstButton = $tabButtons.first();
				if ($firstButton.length) {
					const firstContentId = $firstButton.data('tab-content-id');
					$tabButtons.removeClass('is-active');
					$firstButton.addClass('is-active');
					$tabContents.removeClass('is-active');
					$(`#${firstContentId}`).addClass('is-active');
				}
			}
		});
	}

	function switchTab($button) {
		const $container = $button.closest('[data-tab]');
		if (!$container.length) return;

		const contentId = $button.data('tab-content-id');
		if (!contentId) return;

		const $tabButtons = $container.find('[data-tab-content-id]');
		const $tabContents = $container.find('[data-tab-content]');
		const $targetContent = $(`#${contentId}`);

		// Don't do anything if clicking the already active tab
		if ($button.hasClass('is-active') && $targetContent.hasClass('is-active')) {
			return;
		}

		// Remove is-active class from all buttons in this container
		$tabButtons.removeClass('is-active');

		// Add is-active class to clicked button
		$button.addClass('is-active');

		// Remove is-active class from all content in this container
		$tabContents.removeClass('is-active');

		// Add is-active class to target content
		if ($targetContent.length) {
			$targetContent.addClass('is-active');
		}
	}

	// Initialize tabs on page load
	$(document).ready(function() {
		initTabs();
	});

	// Handle tab button clicks
	$(document).on('click', '[data-tab-content-id]', function(e) {
		e.preventDefault();
		const $button = $(this);
		switchTab($button);
	});

	// Expose global function for programmatic tab switching
	window.switchTab = function(contentId, containerSelector) {
		const $container = containerSelector
			? $(containerSelector).find('[data-tab]').first()
			: $('[data-tab]').first();

		if (!$container.length) return;

		const $button = $container.find(`[data-tab-content-id="${contentId}"]`);
		if ($button.length) {
			switchTab($button);
		}
	};
}());
